import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

const Unauthorized = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
            <div className="max-w-md w-full bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
                <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-4">
                    <ShieldAlert className="w-8 h-8 text-[#E5502E]" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Accès non autorisé</h1>
                <p className="text-gray-600 mb-6">
                    Vous n'avez pas les permissions nécessaires pour accéder à cette page.
                    Contactez le propriétaire de votre boutique si vous pensez que c'est une
                    erreur.
                </p>
                <div className="flex items-center justify-center gap-3">
                    <Link
                        to="/dashboard"
                        className="px-4 py-2 bg-[#E5502E] text-white font-semibold rounded-lg shadow-sm hover:bg-orange-700 transition"
                    >
                        Retour au tableau de bord
                    </Link>
                    <Link
                        to="/vendor/login"
                        className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                    >
                        Se reconnecter
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
